export class FieldDataType {
    Code: string;
    Name: string;
  }